module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro5.aa3bd75f.mp3";